<template>
    <v-container>
        <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            :offset-y="true"
            min-width=""
            content-class="v-menu-content"
            >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="datetimeBr"
                    :label="dataPickerTitle"
                    :prepend-icon="prependIcon"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    ></v-text-field>
            </template>
            <v-date-picker
                v-model="date"
                no-title
                scrollable
                locale="pt-br"
                :type="dataPickerType"
                >
            </v-date-picker>
            <v-spacer></v-spacer>
            <v-time-picker
                v-model="time"
                scrollable
                :landscape="false"
                :no-title="false"
                :use-seconds="false"
                format="24hr"
                ></v-time-picker>
            <v-spacer></v-spacer>
            <v-btn
                v-if="monthEnable"
                text
                color="primary"
                @click="changeDatepickerType()"
                >
                {{ this.dataPickerChangeTypeTxBtn }}
            </v-btn>
            <v-btn
                text
                color="primary"
                @click="menu = false"
                >
                Sair
            </v-btn>
            <v-btn
                text
                color="primary"
                @click="dispatchUpdate(date, time)"
                >
                OK
            </v-btn>
        </v-menu>
    </v-container>
</template>
<script>
    import axios from "axios";
    import { EventBus } from "@/event-bus";
    import { functions } from "../functions";
    import { dateTimeTools } from "../mixins/dateTimeTools";
    import { sort } from "fast-sort";
    import moment from 'moment';

    export default {

        name: "Datepicker2",

        components: {

        },

        props: {
            eventName: String,
            dateInit: String,
            monthEnable: Boolean,
            showIcon: Boolean,
            label: String,
            secBegin: String,
            secEnd: String
        },

        mixins: [dateTimeTools],

        data: function () {
            return {
                dataPickerType: "date",
                dataPickerChangeTypeTxBtn: "Mudar para Mês",
                date: this.dateNow(),
                time: this.dateTimeNow(),
                menu: false,
                modal: false,
                month: null,
                year: null,
                datetime: "",
                datetimeBr: "",
                type: ""
            };
        },

        created: function () {

            if (this.secBegin) {
                this.type = "begin";
            } else if (this.secEnd) {
                this.type = "end";
            }

            if (this.dateInit) {
                console.log("dateInit: " + this.dateInit);
                this.date = this.dateInit.substr(0, 10);
                this.time = this.dateInit.substr(11, 5);
            }

            this.datetime = this.date + " " + this.time;

            if (this.type) {
                this.datetime = this.parseBeginEndData(this.datetime, this.type);
            }

            this.datetimeBr = this.usToBr(this.datetime).substr(0, 16);
        },

        computed: {

            dateFormated() {
                const datetimeIn = this.date.substr(0, 10)
                        + " " + this.time;
                const datetimeOut = moment(datetimeIn).format('DD-MM-YYYY HH:mm:SS');
                return datetimeOut;
            },

            prependIcon() {
                return this.showIcon ? "mdi-calendar" : "";
            },

            dataPickerTitle() {
                return this.label ? this.label : "Dia";
            }
        },

        methods: {

            changeDatepickerType() {
                this.dataPickerType = this.dataPickerType == "date" ? "month" : "date";
                this.dataPickerChangeTypeTxBtn = this.dataPickerType == "date" ? "Mudar para mês" : "Mudar para dia";
                this.dataPickerTitle = this.dataPickerType == "date" ? "Dia" : "Mês";
            },

            parseDateToUrl(date) {
                return date.replaceAll("/", "-");
            },

            dateTimeNow() {
                let dt = new Date();
                return dt.toLocaleString('pt-BR', {timeZone: 'UTC'}).substr(0, 10);
            },

            parseDateToUpdate(date) {
                this.dateStart = this.dateStart ? this.dateStart : this.dateTimeNow();
                this.dateEnd = this.dateEnd ? this.dateEnd : this.dateTimeNow();

                if (date) {
                    this.$refs.menu.save(date);
                    const dt = new Date(date.substr(0, 10));
                    this.date = dt.toISOString().substr(0, 10);
                    this.dateStart = this.date;
                    this.dateEnd = this.date;
                }

                if (this.dataPickerType === "month") {
                    const dt = new Date(this.dateStart);
                    const y = dt.getFullYear();
                    const m = dt.getMonth() + 1;
                    const lastDay = new Date(y, m + 1, 0);
                    this.dateEnd = lastDay.toISOString().substr(0, 10);
                }

                console.log(this.dateStart, this.dateEnd);
            },

            dispatchUpdate(date, time) {
                const datetime = date + " " + time;

                EventBus.$emit(this.eventName, {
                    date: date,
                    time: time,
                    datetime: this.parseBeginEndData(datetime, this.type)
                });

                this.menu = false;
                this.date = date;
                this.time = time;
                this.datetime = datetime;
                this.datetimeBr = this.usToBr(this.datetime).substr(0, 16);

                console.log("Ev Datetime", this.datetime, this.date, this.time);
            }
        }
    };
</script>

<style>
    .v-menu-content {
        background-color: #FFFFFF;
    }
</style>
